// const has = (scope, property) => Boolean(scope[property])

export default function addPolyFills() {
  // array.prototype.includes
  // arrayIncludes()
  // array.prototype.some
  // arraySome()
  addNumberTypeCheckPolyfill()
}

function arrayIncludes() {
  /* eslint-disable no-extend-native */
  if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
      value: function (searchElement, fromIndex) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined')
        }

        // 1. Let O be ? ToObject(this value).
        var o = Object(this)

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0

        // 3. If len is 0, return false.
        if (len === 0) {
          return false
        }

        // 4. Let n be ? ToInteger(fromIndex).
        //    (If fromIndex is undefined, this step produces the value 0.)
        var n = fromIndex | 0

        // 5. If n ≥ 0, then
        //  a. Let k be n.
        // 6. Else n < 0,
        //  a. Let k be len + n.
        //  b. If k < 0, let k be 0.
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)

        function sameValueZero(x, y) {
          return (
            x === y ||
            (typeof x === 'number' &&
              typeof y === 'number' &&
              isNaN(x) &&
              isNaN(y))
          )
        }

        // 7. Repeat, while k < len
        while (k < len) {
          // a. Let elementK be the result of ? Get(O, ! ToString(k)).
          // b. If SameValueZero(searchElement, elementK) is true, return true.
          if (sameValueZero(o[k], searchElement)) {
            return true
          }
          // c. Increase k by 1.
          k++
        }

        // 8. Return false
        return false
      },
    })
  }
}

function arraySome() {
  // Production steps of ECMA-262, Edition 5, 15.4.4.17
  // Reference: http://es5.github.io/#x15.4.4.17
  if (!Array.prototype.some) {
    Array.prototype.some = function (fun /*, thisArg*/) {
      if (this == null) {
        throw new TypeError('Array.prototype.some called on null or undefined')
      }

      if (typeof fun !== 'function') {
        throw new TypeError()
      }

      var t = Object(this)
      var len = t.length >>> 0

      var thisArg = arguments.length >= 2 ? arguments[1] : void 0
      for (var i = 0; i < len; i++) {
        if (i in t && fun.call(thisArg, t[i], i, t)) {
          return true
        }
      }

      return false
    }
  }
}

function addNumberTypeCheckPolyfill() {
  if (!Number.MAX_SAFE_INTEGER) {
    Number.MAX_SAFE_INTEGER = 9007199254740991 // Math.pow(2, 53) - 1;
  }

  Number.isSafeInteger =
    Number.isSafeInteger ||
    function (value) {
      return (
        Number.isInteger(value) && Math.abs(value) <= Number.MAX_SAFE_INTEGER
      )
    }
}
